import EducationAccount from "views/EducationAccount"
import Configuration from "views/configuration/Configuration"
import EuGeneralPurposeStatistics from "views/EuGeneralPurposeStatistics";
import EducationManagement from "views/education/EducationManagement";
import DemandAnalytics from "views/demand/analytics/DemandAnalytics"
import DemandForecasting from "views/demand/forecasting/DemandForecasting"
import SupplyAnalytics from "views/supply/analytics/SupplyAnalytics"
import SupplyForecasting from "views/supply/forecasting/SupplyForecasting"
import TaxonomyManagement from "views/taxonomies/TaxonomyManagement";
import ManagePolicies from "views/policies/ManagePolicies";
import Recommendations from "views/education/Recommendations";
import GenerateReport from "views/education/GenerateReport";
import { ProjectorAnalytics } from "views/supply/projector/ProjectorAnalytics";

var routes = [
  {
    path: "/account",
    name: "My University",
    icon: "nc-icon nc-single-02",
    component: <EducationAccount />,
    layout: "/education",
  },
  {
    path: "/account/management",
    name: "Management",
    icon: "nc-icon nc-single-02",
    component: <EducationManagement />,
    layout: "/education",
  },
  {
    path: "/account/taxonomy",
    name: "Taxonomy",
    icon: "nc-icon nc-single-02",
    component: <TaxonomyManagement />,
    layout: "/education",
  },
  {
    path: "/account/manage-policies",
    name: "Manage Policies",
    icon: "nc-icon nc-single-02",
    component: <ManagePolicies />,
    layout: "/education",
  },
  {
    path: "/account/recommendations",
    name: "Recommendations",
    icon: "nc-icon nc-single-02",
    component: <Recommendations />,
    layout: "/education",
  },
  {
    path: "/account/generate-report",
    name: "Generate Report",
    icon: "nc-icon nc-single-02",
    component: <GenerateReport />,
    layout: "/education",
  },
  {
    name: "Demand",
    isCategory: true, 
    children: [
      {
        path: "/demand-analytics",
        name: "Analytics",
        icon: "nc-icon nc-zoom-split",
        component: <DemandAnalytics />,
        layout: "/education",
      },
      {
        path: "/demand-forecasting",
        name: "Forecasting",
        icon: "nc-icon nc-chart-pie-36",
        component: <DemandForecasting />,
        layout: "/education",
      },
      {
        path: "/projector-analytics",
        name: "Projector",
        icon: "nc-icon nc-map-big",
        component: <ProjectorAnalytics />,
        layout: "/education",
      },
    ],
  },
  {
    name: "Supply",
    isCategory: true,
    children: [
      {
        path: "/supply-analytics",
        name: "Analytics",
        icon: "nc-icon nc-zoom-split",
        component: <SupplyAnalytics />,
        layout: "/education",
      },
      {
        path: "/supply-forecasting",
        name: "Forecasting",
        icon: "nc-icon nc-chart-pie-36",
        component: <SupplyForecasting />,
        layout: "/education",
      },
    ],
  },
  {
    path: "/configuration",
    name: "Configuration",
    icon: "nc-icon nc-settings",
    component: <Configuration />,
    layout: "/education",
  },
];
export default routes;
